module.exports = __webpack_public_path__ + "img/SchlagtMichZumRitter.9818e528.jpg";